import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useActualityStore = defineStore('actuality', {
    state: () => {
        return {
            all: null,
            meta: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.ACTUALITY.INDEX.replace(':page', 1))

                this.all = data.data
                this.meta = data.meta
            } catch { /**/ }
        },
        async fetchNextPage() {
            try {
                if(this.meta.last_page >= this.meta.current_page + 1) {
                    const {data} = await http.get(API_ENDPOINTS.ACTUALITY.INDEX.replace(':page', this.meta.current_page + 1))

                    if (data.data?.length) {
                        this.all = this.all.concat(data.data)
                        this.meta = data.meta
                    }
                }
            } catch { /**/ }
        },
        async storeComment(id, payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.ACTUALITY.COMMENT.STORE.replace(':id', id), payload)

                this.all = this.all.map(actuality => {
                    if (actuality.id.toString() === id.toString()) {
                        actuality.comments.push(data)
                    }

                    return actuality
                })
            } catch { /**/ }
        },
        async like(id, payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.ACTUALITY.LIKE.replace(':id', id), payload)

                this.all = this.all.map(actuality => {
                    if (actuality.id.toString() === id.toString()) {
                        if (data.data) {
                            actuality.likes.push(data.data)
                        } else {
                            actuality.likes = actuality.likes.filter(like => like.user_id !== payload.user_id)
                        }
                    }
                    return actuality
                })

            } catch { /**/ }
        },
        async uploadImages(id, { newFiles = [], existingIds = [] }) {
            try {
                const formData = new FormData()

                existingIds.forEach(existingId => {
                    formData.append('existing_images[]', existingId)
                })

                newFiles.forEach(file => {
                    formData.append('images[]', file)
                })

                const { data } = await http.post(
                    API_ENDPOINTS.ACTUALITY.UPLOAD_IMAGES.replace(':id', id),
                    formData
                )

                this.all = this.all.map(actuality => {
                    if (actuality.id.toString() === id.toString()) {
                        actuality.images = data.data
                    }
                    return actuality
                })
            } catch { /**/ }
        },
        async get(id) {
            try {
                const actualityById = this.all.find(a => a.id.toString() === id.toString())
                if(actualityById) return actualityById

                const { data } = await http.get(API_ENDPOINTS.ACTUALITY.SHOW.replace(':id', id))
                return data
            } catch { /**/ }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.ACTUALITY.DESTROY.replace(':id', id))

                this.all = this.all.filter(actuality => actuality.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.ACTUALITY.STORE, payload)

                this.all.unshift(data)

                return data.id
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.ACTUALITY.UPDATE.replace(':id', id), payload)

                this.all = this.all.map(actuality => {
                    if (actuality.id.toString() === id.toString()) {
                        actuality = data
                    }

                    return actuality
                })

                return data.id
            } catch { /**/ }
        }
    }
})